import { useMediaQuery, useTheme } from '@mui/material';
import useMsalUser from '@shared/hooks/useMsalUser';
import appLogger from '@shared/logging/appLogger';
import type {} from '@shared/utilities/horizon/components';
import { useEffect } from 'react';

import styles from './InternalError.module.scss';

const SleepRobotIcon = ({ width }: { width: number }) => {
    return (
        <svg
            aria-labelledby="sleepRobotIcon"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            viewBox="0 0 480 270"
            data-testid="robotIcon">
            <title id="sleepRobotIcon">Service Error Icon</title>
            <g id="_ÎÓÈ_1" data-name="—ÎÓÈ_1" />
            <g id="_00_Medium" data-name="500_Medium">
                <ellipse
                    id="shadow"
                    cx="124.949"
                    cy="263.338"
                    rx="103.166"
                    ry="6.662"
                    fill="#e0f2ff"
                />
                <g id="robot">
                    <path
                        d="M92.549,152.771s-6.318,5.428-6.318,18.719h47.823v-11.392l-41.505-7.327Z"
                        fill="#0559ad"
                    />
                    <path
                        d="M146.544,168.231h-57.963c-15.666,0-34.465-4.258-36.814,28.103-2.166,29.823-1.566,31.51-2.35,45.136-.782,13.599,13.316,22.142,36.031,22.142h64.229c17.232,0,26.632-.852,26.632-24.697v-44.284c0-9.368-3.133-26.4-29.765-26.4Z"
                        fill="#9ccef7"
                    />
                    <path
                        d="M94.063,168.216c-15.666,0-43.081-3.916-45.43,25.848-2.166,27.43-1.567,28.981-2.35,41.514-.782,12.508,7.833,28.198,30.548,28.198,19.74,0,2.474-42.424,17.232-95.561Z"
                        fill="#c2e3fc"
                    />
                    <g>
                        <path
                            d="M193.932,263.777h-48.105c-3.498,0-6.333-2.835-6.333-6.333h0c0-4.722,3.828-8.549,8.549-8.549h45.889c4.11,0,7.441,3.332,7.441,7.441h0c0,4.11-3.332,7.441-7.441,7.441Z"
                            fill="#4094e3"
                        />
                        <path
                            d="M203.291,227.1s-13.667-4.838-17.583,8.478c-3.916,13.316,0,21.932,4.7,25.848,4.7,3.916,9.164,1.374,9.164,1.374l3.72-35.7Z"
                            fill="#4094e3"
                        />
                        <path
                            d="M198.991,262.777c7.801,.7,10.554-13.986,10.892-24.975,.41-13.333-12.783-15.303-14.183,.3-1.4,15.603-2.95,24.115,3.291,24.675Z"
                            fill="#0559ad"
                        />
                    </g>
                    <path
                        d="M146.544,168.216h-48.353l2.139,1.016s54.566,29.645,75.979,25.814v-2.548c0-8.616-3.133-24.282-29.765-24.282Z"
                        fill="#4094e3"
                    />
                    <path
                        d="M176.308,88.321c-30.041-16.618-72.062-23.498-95.561,10.966-23.498,34.464-21.149,47.78,0,55.613,21.149,7.833,52.48,20.365,67.363,25.848,14.882,5.483,38.381,10.966,52.48-18.016,14.099-28.982,12.533-54.047-24.282-74.412Z"
                        fill="#f1f9f9"
                    />
                    <path
                        d="M176.308,88.321c-30.041-16.618-72.062-23.498-95.561,10.966-23.498,34.464-21.149,47.78,0,55.613,21.149,7.833,52.48,20.365,67.363,25.848,14.882,5.483,38.381,10.966,52.48-18.016,14.099-28.982,12.533-54.047-24.282-74.412Z"
                        fill="#9ccef7"
                    />
                    <path
                        d="M190.462,97.725c-3.982-3.237-8.675-6.373-14.154-9.404-30.041-16.618-72.062-23.498-95.561,10.966-23.498,34.464-21.149,47.78,0,55.613,4.974,1.842,9.068,3.387,14.822,5.596,20.314-71.75,67.526-72.696,94.893-62.772Z"
                        fill="#c2e3fc"
                    />
                    <g>
                        <path
                            d="M146.152,263.777h-37.139c-3.498,0-6.333-2.835-6.333-6.333h0c0-4.722,3.828-8.549,8.549-8.549h34.923c4.11,0,7.441,3.332,7.441,7.441h0c0,4.11-3.332,7.441-7.441,7.441Z"
                            fill="#4094e3"
                        />
                        <path
                            d="M155.511,227.1s-13.667-4.838-17.583,8.478c-3.916,13.316,0,21.932,4.7,25.848,4.7,3.916,9.164,1.374,9.164,1.374l3.72-35.7Z"
                            fill="#4094e3"
                        />
                        <path
                            d="M151.21,262.777c7.802,.7,10.554-13.986,10.892-24.975,.41-13.333-12.783-15.303-14.183,.3-1.4,15.603-2.95,24.115,3.291,24.675Z"
                            fill="#004487"
                        />
                    </g>
                    <path
                        d="M69.088,183.364s-7.809,23.521,4.379,36.672c23.435,1.89,19.617,36.499,19.617,36.499,0,0-21.275,8.537-29.091-4.168-7.816-12.705,1.806-23.431,1.806-23.431,0,0-11.978-18.447-4.866-44.986l8.155-.585Z"
                        fill="#c2e3fc"
                    />
                    <path
                        d="M74.003,244.181c-3.744-5.596-2.023-9.613-1.936-9.88,.167-.514,.639-.867,1.179-.882,7.004-.18,7.195,2.733,8.379,7.1,.539,1.985,3.134,2.865,3.899,3.104,.697-5.88-.393-10.353-3.247-13.31-4.92-5.097-13.613-4.136-13.7-4.127-.569,.065-1.106-.249-1.327-.773-8.485-20.253-2.626-34.901,1.837-42.05,1.413-2.264,.036-5.225-2.61-5.579l-.067-.009-.085-.011c-3.87-.497-7.525,1.93-8.772,5.626-2.903,8.597-6.656,26.618,4.035,44.73l1.511,2.252c-1.588,2.25-5.094,7.98-4.49,13.987,.369,3.678,2.24,6.921,5.56,9.64,1.166,.337,6.688,1.815,11.941,1.419,0,0,3.065,.394,6.398-.307,2.459-.517,2.616-3.959,.232-4.755-3.944-1.317-6.87-3.381-8.739-6.175Z"
                        fill="#004487"
                    />
                    <path
                        d="M111.296,109.47c-9.736,20.222-7.05,40.731,36.031,55.613,43.081,14.882,51.697-8.616,54.047-22.715,2.35-14.099-7.05-31.331-31.331-43.081-24.282-11.749-48.564-10.966-58.746,10.183Z"
                        fill="#e0f2ff"
                    />
                    <g>
                        <path
                            d="M147.43,129.758c-4.294,0-7.753-1.124-10.314-3.36-4.23-3.692-4.279-9.009-4.279-9.234,0-1.082,.877-1.958,1.958-1.958s1.953,.871,1.958,1.947c.001,.073,.092,3.839,2.973,6.325,2.413,2.081,6.151,2.795,11.103,2.117,1.078-.143,2.058,.605,2.205,1.676,.146,1.072-.604,2.059-1.676,2.205-1.378,.187-2.689,.281-3.929,.281Zm-10.677-12.594h0Z"
                            fill="#004487"
                        />
                        <path
                            d="M181.611,144.077c-2.896,0-5.42-.681-7.546-2.039-4.732-3.024-5.569-8.276-5.602-8.497-.16-1.069,.577-2.067,1.646-2.228,1.073-.156,2.061,.572,2.226,1.636,.013,.077,.662,3.785,3.878,5.814,2.695,1.702,6.496,1.851,11.296,.447,1.034-.301,2.125,.292,2.429,1.33,.304,1.038-.292,2.125-1.33,2.429-2.527,.739-4.863,1.108-6.996,1.108Z"
                            fill="#004487"
                        />
                    </g>
                    <path
                        d="M170.042,99.287c-24.282-11.749-48.564-10.966-58.746,10.183-.951,1.975-1.782,3.953-2.469,5.929,.458-1.129,.96-2.259,1.503-3.387,9.88-20.519,33.439-21.279,56.998-9.88,23.559,11.4,32.679,28.119,30.399,41.799-1.445,8.671-5.338,21.004-18.638,25.196,16.2-3.283,20.689-17.185,22.284-26.758,2.35-14.099-7.05-31.331-31.331-43.081Z"
                        fill="#4094e3"
                    />
                    <path
                        d="M142.341,212.544h0c-1.017,0-1.849-.832-1.849-1.849v-23.724c0-1.017,.832-1.849,1.849-1.849h0c1.017,0,1.849,.832,1.849,1.849v23.724c0,1.017-.832,1.849-1.849,1.849Z"
                        fill="#4094e3"
                    />
                    <path
                        d="M159.432,60.009c4.332-1.526,8.255-2.133,10.971-2.368,.701-2.273,3.019-3.696,5.405-3.227,2.551,.502,4.212,2.976,3.711,5.527-.502,2.551-2.976,4.212-5.527,3.711-1.764-.347-3.102-1.638-3.594-3.245-2.552,.239-6.194,.823-10.149,2.228-9.878,3.508-16.957,10.216-21.039,19.937l-2.533-1.063c5.492-13.078,15.406-18.91,22.755-21.499Z"
                        fill="#0559ad"
                    />
                </g>
                <path
                    id="cloud"
                    d="M239.063,56.914c16.855-49.276,71.972-36.517,71.972-36.517,45.024-46.374,149.834-7.469,147.131,54.538-3.237,74.261-69.208,61.585-69.208,61.585-41.815,39.768-78.253-3.51-78.253-3.51-26.158,32.277-69.166,38.034-69.166,38.034,28.212-20.649,37.25-48.765,37.25-48.765-25.713,.602-52.085-29.232-39.726-65.366Z"
                    fill="#ffd900"
                />
                <path
                    id="ZZZ"
                    d="M325.261,87.354h-18.974l18.473-26.548v-5.278h-27.709v6.756h17.998l-18.5,26.522v5.304h28.712v-6.756Zm26.047,.607h-13.776l13.301-18.13v-5.225h-22.009v6.149h12.851l-13.669,18.605v4.75h23.302v-6.149Zm26.363,0h-13.776l13.301-18.13v-5.225h-22.009v6.149h12.852l-13.669,18.605v4.75h23.302v-6.149Zm5.912,5.686c.808,.783,1.952,1.175,3.43,1.175,1.443,0,2.569-.401,3.378-1.201,.809-.801,1.215-1.896,1.215-3.286,0-1.442-.401-2.55-1.201-3.324-.801-.774-1.932-1.161-3.392-1.161-1.513,0-2.665,.378-3.457,1.134s-1.188,1.873-1.188,3.351c0,1.426,.405,2.53,1.215,3.312Zm15.412,0c.808,.783,1.952,1.175,3.43,1.175,1.443,0,2.569-.401,3.378-1.201,.809-.801,1.215-1.896,1.215-3.286,0-1.442-.401-2.55-1.201-3.324-.801-.774-1.931-1.161-3.392-1.161-1.513,0-2.665,.378-3.457,1.134s-1.188,1.873-1.188,3.351c0,1.426,.405,2.53,1.215,3.312Z"
                    fill="#053361"
                />
            </g>
        </svg>
    );
};

export default function InternalError() {
    const theme = useTheme();
    const { getUser, isAuthenticated, redirectToLogin } = useMsalUser();
    const smallScreenMatch = useMediaQuery(theme.breakpoints.down('sm'));
    const robotIconWidth = smallScreenMatch ? 268 : 368;
    const headingSize = smallScreenMatch ? 'small' : 'medium';
    const lineHeight = smallScreenMatch ? 'xsmall' : 'base';

    useEffect(
        () =>
            appLogger.logPageView({
                name: 'Internal Error - Sad Robot',
                refUri: `${window.location.href}`,
            }),
        []
    );

    useEffect(() => {
        if (isAuthenticated && !getUser()) {
            redirectToLogin();
        }
    }, [getUser, isAuthenticated]);

    return (
        <div className={styles['internal-error']}>
            <hzn-stack space="base" align-x="center" align-y="center">
                <SleepRobotIcon width={robotIconWidth} />
                <hzn-heading as="h1" align="center" size={headingSize} line-height={lineHeight}>
                    Service currently unavailable
                </hzn-heading>
                <div className={styles['page-body']}>
                    <hzn-text
                        variant="text"
                        size="base"
                        tone="body"
                        weight="base"
                        align="center"
                        as="p"
                        line-height="base">
                        Looks like our connection has taken a detour. Try again in a bit or contact{' '}
                        <hzn-text-link href={process.env.AUCTIONS_HOMEPAGE_URL + '/contact-us'}>
                            Auction Services
                        </hzn-text-link>{' '}
                        if the issue continues.
                    </hzn-text>
                </div>
            </hzn-stack>
        </div>
    );
}
